/* Sinneszauber Saisond\u00fcfte
   Duftfamilien laut Olfazeta-Parfumkatalog (Stand 04/10/2026), nur Duftnummern.
   Jede Jahreszeit fasst passende Familien zusammen. Ben\u00f6tigt mixer.js. */
(function () {
  // Duftnummern je Familie (Suffixe W/M/U entfallen, Namen f\u00fcr D\u00fcfte ohne Nummer)
  const FAMILY = {
    fruchtig: { label: 'Fruchtig', ids: [89, 93, 96, 97, 120, 159, 78, 86, 167, 110, 111, 129, 134] },
    zitrisch: { label: 'Zitrisch frisch', ids: [21, 60, 62, 79, 87, 113, 44, 73, 99, 155, 112, 125, 130] },
    blumig_suess: { label: 'Blumig s\u00fc\u00df', ids: [7, 10, 14, 19, 27, 39, 40, 42, 47, 51, 55, 80, 81, 82, 121, 122, 131, 133, 151, 158, 161, 163, 109, 123, 126] },
    holzig: { label: 'Holzig', ids: [1, 3, 18, 22, 30, 31, 32, 38, 52, 66, 88, 152, 157, 160, 162, 164, 72, 114, 135, 74, 75, 101, 102, 127] },
    blumig_pudrig: { label: 'Blumig pudrig', ids: [24, 25, 26, 34, 36, 53, 56, 57, 70, 90, 154, 136] },
    orientalisch: { label: 'Orientalisch', ids: [6, 71, 4, 12, 15, 16, 20, 33, 37, 48, 83, 92, 150, 54, 100, 106, 117, 118, 128, 137, 138, 139], names: ['multivers', 'volt'] },
    blumig_frisch: { label: 'Blumig frisch', ids: [49, 64, 67, 85, 98, 107, 115, 153, 156, 146], names: ['astral'] },
    gourmand: { label: 'Gourmand s\u00fc\u00df', ids: [8, 23, 28, 35, 42, 55, 90, 116, 119, 131, 145, 105, 143, 144, 163, 111, 124], names: ['amphera'] },
    aquatisch: { label: 'Aquatisch frisch', ids: [11, 29, 76, 2, 61, 69, 84, 91] },
  };
  const SEASONS = {
    herbst: { name: 'Herbst', title: 'Herbstd\u00fcfte', families: ['holzig', 'orientalisch', 'gourmand'],
      intro: 'Wenn die Bl\u00e4tter fallen, d\u00fcrfen D\u00fcfte w\u00e4rmer werden: holzige Tiefe, orientalische W\u00fcrze und s\u00fc\u00dfe Gourmand-Noten wie Vanille, Kaffee und Tonka.' },
    winter: { name: 'Winter', title: 'Winterd\u00fcfte', families: ['orientalisch', 'gourmand', 'holzig'],
      intro: 'Kalte Tage, warme D\u00fcfte: intensive orientalische Kompositionen, s\u00fc\u00dfe Gourmand-Noten und edle H\u00f6lzer, die lange auf der Haut bleiben.' },
    fruehling: { name: 'Fr\u00fchling', title: 'Fr\u00fchlingsd\u00fcfte', families: ['blumig_frisch', 'blumig_suess', 'fruchtig', 'blumig_pudrig'],
      intro: 'Alles erwacht: frische und s\u00fc\u00dfe Bl\u00fctend\u00fcfte, saftige Fr\u00fcchte und zarte, pudrige Noten f\u00fcr die ersten warmen Tage.' },
    sommer: { name: 'Sommer', title: 'Sommerd\u00fcfte', families: ['zitrisch', 'aquatisch', 'fruchtig', 'blumig_frisch'],
      intro: 'Leicht, frisch, sonnig: spritzige Zitrusnoten, Meeresfrische und fruchtige D\u00fcfte, die auch an hei\u00dfen Tagen nicht schwer werden.' },
  };

  // Duftnummer aus dem Produkttitel: "105 - Espresso" -> 105, "IMPERATRIX - \u2026" -> Name
  function keyOf(title) {
    const t = String(title || '').trim();
    const m = t.match(/^0*(\d{1,3})\s*[-\u2013|]/);
    if (m) return { id: Number(m[1]), name: '' };
    return { id: null, name: t.split(/[-\u2013|]/)[0].trim().toLowerCase() };
  }
  function familiesOf(title) {
    const k = keyOf(title);
    return Object.keys(FAMILY).filter((f) => {
      const F = FAMILY[f];
      if (k.id != null) return F.ids.includes(k.id);
      return (F.names || []).some((n) => k.name.startsWith(n));
    });
  }
  function inSeason(title, season) {
    const s = SEASONS[season];
    return !!s && familiesOf(title).some((f) => s.families.includes(f));
  }

  // Saisonseite: Familien-Filter + Karten (wie im Duft-Mixer, mit Gr\u00f6\u00dfenwahl)
  function renderPage(el, products, season, opts = {}) {
    const s = SEASONS[season] || SEASONS.herbst;
    const list = products
      .filter((p) => inSeason(p.title, season))
      .map((p) => ({ ...p, ...window.SZMixer.profile(p.notes || ''), fams: familiesOf(p.title) }));
    let active = 'alle';
    el.innerHTML = `<div class="season-filter" role="group" aria-label="Duftfamilie">
        <button type="button" class="mx-chip is-on" data-fam="alle">Alle ${s.title} <span>${list.length}</span></button>
        ${s.families.map((f) => { const n = list.filter((p) => p.fams.includes(f)).length; return n ? `<button type="button" class="mx-chip" data-fam="${f}">${FAMILY[f].label} <span>${n}</span></button>` : ''; }).join('')}
      </div>
      <div class="mx-grid season-grid"></div>`;
    const grid = el.querySelector('.season-grid');
    const draw = () => {
      const l = active === 'alle' ? list : list.filter((p) => p.fams.includes(active));
      grid.innerHTML = l.length ? l.map((p) => window.SZMixer.renderCard(p, opts)).join('') : '<p class="mx-empty">Gerade keine D\u00fcfte in dieser Familie.</p>';
      window.SZNotes && SZNotes.init(grid);
      window.SZWish && SZWish.sync(grid);
    };
    window.SZMixer.bindGrid(grid, opts);
    el.querySelectorAll('[data-fam]').forEach((b) => b.addEventListener('click', () => {
      active = b.dataset.fam;
      el.querySelectorAll('[data-fam]').forEach((x) => x.classList.toggle('is-on', x === b));
      draw();
    }));
    draw();
    return list.length;
  }

  window.SZSeasons = { FAMILY, SEASONS, keyOf, familiesOf, inSeason, renderPage };
})();
